import React, { useEffect, useRef, useState } from 'react'
import { Button, DatePicker, Input, Modal, Select, Table } from 'antd'
import 'aos/dist/aos.css'
import { Option } from 'antd/es/mentions'
import axios from 'axios'
import { toast } from 'react-toastify'
import {
  CloseOrderEntry,
  DeleteOrderEntrySecond,
  DeleteOrderEntryThird,
  GetColorCode,
  getLatestRate,
  GetOrderEntry,
  GetOrderEntryFirst,
  GetOrderEntryFirstById,
  GetOrderEntrySecond,
  GetOrderEntrySecondById,
  GetOrderEntryThird,
  GetOrderEntryThirdById,
  SaveOrderEntryFirst,
  SaveOrderEntrySecond,
  SaveOrderEntryThird,
  UpdateOrderEntryFirst,
  UpdateOrderEntrySecond,
} from '../../AllAPI/SalesAPI/SalesApi'
import { GetCustomerMaster } from '../../AllAPI/MasterAPI/SalesMasterApi'
import { DieNameMasterGet } from '../../AllAPI/MasterAPI/DiesMasterApi'
import dayjs from 'dayjs'
import { GetAlloyMaster } from '../../AllAPI/MasterAPI/GeneralMasterApi'
import { TemperMasterGet } from '../../AllAPI/MasterAPI/ProductionMasterApi'

const OrderEntry = () => {
  // Inside your component
  const addToStackBtnRef = useRef(null)
  const itemNameBtnRef = useRef(null)

  const handlePremiumKeyDown = (e) => {
    if (e.key === 'Enter' || e.key === 'Tab') {
      e.preventDefault() // prevent form submission or default tabbing
      addToStackBtnRef.current?.focus()
    }
  }

  const storedHeaders = JSON.parse(sessionStorage.getItem('authHeaders')) || {}
  const currentYear = sessionStorage.getItem('currentYear')
  // const storedUserData = sessionStorage.getItem('userData') || '';

  const commonHeaders = {
    headers: {
      // createdBy: storedUserData || '',
      // updatedBy: storedUserData || '',
      createdBy: 1,
      updatedBy: 2,
      userIp: storedHeaders.userIp || '',
      userLat: storedHeaders.userLat || '',
      userLong: storedHeaders.userLong || '',
      deviceSign: storedHeaders.deviceSign || '',
    },
  }

  const commonHeaders1 = {
    headers: {
      createdBy: 1,
      updatedBy: 2,
    },
  }

  const [errors, setErrors] = useState({
    poNumber: '',
    poDate: '',
    customerName: '',
    // customerRate: "",
    customerInstruction: '',
    basicOrderEntryRate: '',
    // premiumEntry: "",
    packingEntryRate: '',
    packingRemark: '',
    colorCode: '',
    stickerCode: '',
    nalcoRate: '',
    sixtyThreeRate: '',
    commercialRate: '',
    // AttachPOFile: "",

    orderDetailsNumber: '',
    alloy: '',
    length: '',
    basicOrderDetailsRate: '',
    itemName: '',
    temper: '',
    pcs: '',
    packingDetailsRate: '',
    unit: '',
    weightRange: '',
    qty: '',
    premiumDetails: '',
    totalRate: '',
  })

  const [pageSize, setPageSize] = useState(10)
  const [filteredData, setFilteredData] = useState([])
  const [currentPage, setCurrentPage] = useState(1)
  const [totalEntries, setTotalEntries] = useState(0)

  const [pageSize1, setPageSize1] = useState(10)
  const [filteredData1, setFilteredData1] = useState([])
  const [currentPage1, setCurrentPage1] = useState(1)
  const [totalEntries1, setTotalEntries1] = useState(0)

  const [pageSize2, setPageSize2] = useState(10)
  const [filteredData2, setFilteredData2] = useState([])
  const [currentPage2, setCurrentPage2] = useState(1)
  const [totalEntries2, setTotalEntries2] = useState(0)

  const [orderId, setOrderId] = useState('')

  // ============ORDER ENTRY=================

  const [orderNumberIdForTemp, setOrderNumberIdForTemp] = useState('')

  const [orderNumber, setOrderNumber] = useState('')
  const [orderDate, setOrderDate] = useState('')
  const [poNumber, setPoNumber] = useState('')
  const [poNumberDetails, setPoNumberDetails] = useState('')
  const [poDate, setPoDate] = useState(dayjs())
  const [customerName, setCustomerName] = useState('')
  const [customerNameDetails, setCustomerNameDetails] = useState('')
  const [customerNameId, setCustomerNameId] = useState('')
  // const [customerRate, setCustomerRate] = useState("");
  const [customerInstruction, setCustomerInstruction] = useState('')
  const [basicOrderEntryRate, setBasicOrderEntryRate] = useState('')
  const [packingEntryRate, setPackingEntryRate] = useState('')
  // const [premiumEntry, setPremiumEntry] = useState("");
  const [packingRemark, setPackingRemark] = useState('')
  const [colorCode, setColorCode] = useState('')
  const [stickerCode, setStickerCode] = useState('')
  const [nalcoRate, setNalcoRate] = useState('')
  const [sixtyThreeRate, setSixtyThreeRate] = useState('')
  const [commercialRate, setCommercialRate] = useState('')
  const [e91ERate, setE91ERate] = useState('')

  //=======Customer Edit=====================
  const [customerInstructionEdit, setCustomerInstructionEdit] = useState('')
  const [basicOrderEntryRateEdit, setBasicOrderEntryRateEdit] = useState('')
  const [packingEntryRateEdit, setPackingEntryRateEdit] = useState('')
  const [packingRemarkEdit, setPackingRemarkEdit] = useState('')
  const [poNumberEdit, setPoNumberEdit] = useState('')
  const [poDateEdit, setPoDateEdit] = useState(dayjs())
  const [customerNameEdit, setCustomerNameEdit] = useState('')
  const [colorCodeEdit, setColorCodeEdit] = useState('')
  const [stickerCodeEdit, setStickerCodeEdit] = useState('')

  // ============ORDER DETAILS=================
  const [isModalVisible, setIsModalVisible] = useState(false)

  const [orderDetailsNumber, setOrderDetailsNumber] = useState('')
  const [alloy, setAlloy] = useState(1)
  const [lengthDetails, setLengthDetails] = useState('')
  const [basicOrderDetailsRate, setBasicOrderDetailsRate] = useState('')
  const [itemName, setItemName] = useState('')
  const [temper, setTemper] = useState(1)
  const [pcs, setPcs] = useState('')
  const [packingDetailsRate, setPackingDetailsRate] = useState('')
  const [unit, setUnit] = useState('1')
  const [weightRange, setWeightRange] = useState('')
  const [qty, setQty] = useState('')
  const [premiumDetails, setPremiumDetails] = useState('')
  const [premiumDetails1, setPremiumDetails1] = useState('')
  const [totalRate, setTotalRate] = useState('')

  //==================MODAL INPUTS=================
  const [orderDetailsId, setOrderDetailsId] = useState('')
  const [orderDId, setOrderDId] = useState('')

  const [orderDetailsNumberModal, setOrderDetailsNumberModal] = useState('')
  const [alloyModal, setAlloyModal] = useState('')
  const [lengthDetailsModal, setLengthDetailsModal] = useState('')
  const [basicOrderDetailsRateModal, setBasicOrderDetailsRateModal] = useState(
    '',
  )
  const [itemNameModal, setItemNameModal] = useState('')
  const [temperModal, setTemperModal] = useState('')
  const [pcsModal, setPcsModal] = useState('')
  const [packingDetailsRateModal, setPackingDetailsRateModal] = useState('')
  const [unitModal, setUnitModal] = useState('')
  const [weightRangeModal, setWeightRangeModal] = useState('')
  const [qtyModal, setQtyModal] = useState('')
  const [premiumDetailsModal, setPremiumDetailsModal] = useState('')
  const [totalRateModal, setTotalRateModal] = useState('')
  const [customerNameIdModal, setCustomerNameIdModal] = useState('')

  const [orderNumberModal, setOrderNumberModal] = useState('')
  const [orderDateModal, setOrderDateModal] = useState('')
  const [customerNameDetailsModal, setCustomerNameDetailsModal] = useState('')
  const [poNumberDetailsModal, setPoNumberDetailsModal] = useState('')

  const [prevImgModal, setPrevImgModal] = useState('')

  const [allAlloy, setAllAlloy] = useState([])
  const [allCustomers, setAllCustomers] = useState([])
  const [allItems, setAllItems] = useState([])
  const [allTemper, setAllTemper] = useState([])

  const [allOrderEntryData, setAllOrderEntryData] = useState([])
  const [allOrderEntryTempData, setAllOrderEntryTempData] = useState([])
  const [allOrderEntryFinalData, setAllOrderEntryFinalData] = useState([])
  const [colorOptions, setColorOptions] = useState([])

  // const [showOrderEntry, setShowOrderEntry] = useState(false);
  const [showTable, setShowTable] = useState(true)
  const [showOrderDetails, setShowOrderDetails] = useState(false)

  //===================Customer Data Edit MODAL=======================================

  const [isCustomerModalVisible, setIsCustomerModalVisible] = useState(false)
  const [editingRecord, setEditingRecord] = useState(null)

  const handleEditCustomerData = (record) => {

    const colorCodeForEdit =parseInt(record.colorCode)

    setEditingRecord(record)
    setCustomerNameEdit(record.customerNameId) // assuming you store ID
    setPoNumberEdit(record.poNumber)
    setPoDateEdit(dayjs(record.poDate)) // use `dayjs` if using `DatePicker`
    setCustomerInstructionEdit(record.customerInstruction)
    setBasicOrderEntryRateEdit(record.basicOrderRate)
    setPackingRemarkEdit(record.packingRemark)
    setPackingEntryRateEdit(record.packingRate)
    setColorCodeEdit(colorCodeForEdit);
    setStickerCodeEdit(record.stickerCode);

    setIsCustomerModalVisible(true)
  }

  const handleOrderEntryCustomerUpdate = async () => {

    let isValid = true;
        const errorObj = {};  
    
        if (!customerNameEdit) {
          isValid = false;
          errorObj.customerNameEdit = "Customer Name is required *";
        }
        if (!poNumberEdit) {
          isValid = false;
          errorObj.poNumberEdit = "PO Number is required *";
        }
        if (!poDateEdit) {
          isValid = false;
          errorObj.poDateEdit = "PO Date is required *";
        }
        if (!customerInstructionEdit) {
          isValid = false;
          errorObj.customerInstructionEdit = "Customer Instruction is required *";
        }
        if (!basicOrderEntryRateEdit) {
          isValid = false;
          errorObj.basicOrderEntryRateEdit = "Basic Order Rate is required *";
        }
        if (!packingRemarkEdit) {
          isValid = false;
          errorObj.packingRemarkEdit = "Packing Remark is required *";
        }
        if (!packingEntryRateEdit) {
          isValid = false;
          errorObj.packingEntryRateEdit = "Packing Entry is required *";
        }
        if (!colorCodeEdit) {
          isValid = false;
          errorObj.colorCodeEdit = "Color Code is required *";
        }
        if (!stickerCodeEdit) {
          isValid = false;
          errorObj.stickerCodeEdit = "Sticker Code is required *";
        }

     
    setErrors(errorObj); // Set error messages
    
        if (!isValid) return;

    const payload = {
      id: editingRecord.id,
      poNumber: poNumberEdit,
      poDate: poDateEdit ? poDateEdit.format('YYYY-MM-DD') : null,
      customerNameId: customerNameEdit,
      basicOrderRate: parseFloat(basicOrderEntryRateEdit),
      packingRate: packingEntryRateEdit,
      packingRemark: packingRemarkEdit,
      customerInstruction: customerInstructionEdit,
      stickerCode: stickerCodeEdit,
      colorCode: parseInt(colorCodeEdit),
    }

    try {
      const response = await axios.put(
        UpdateOrderEntryFirst,
        payload,
        commonHeaders,
      )
      if (response.data == 'UPDATED') {
        toast.success('Order updated successfully!')
        setIsCustomerModalVisible(false)
        fetchOrderEntryData()
      } else {
        toast.error('Update failed!')
      }
    } catch (err) {
      console.error(err)
      toast.error({ message: 'Something went wrong!' })
    }
  }

  //=============================================================

  const handleShowForm = () => {
    setShowTable(false)
    // setShowOrderEntry(true)
  }

  //======Search data from temp (second) table===============
  const handleSearch = (value) => {
    const searchValue = value.toLowerCase()

    const filtered = allOrderEntryTempData.filter((item) =>
      Object.values(item).some((val) =>
        String(val ?? '')
          .toLowerCase()
          .includes(searchValue),
      ),
    )

    setFilteredData(filtered)
    setTotalEntries(filtered.length)
    setCurrentPage(1)
  }

  //==========Pagination=======================
  const handlePageSizeChange = (value) => {
    setPageSize(value)
  }

  //======Search data from final (third) table===============
  const handleSearch1 = (value) => {
    const searchValue = value.toLowerCase()

    const filtered = allOrderEntryFinalData.filter((item) =>
      Object.values(item).some((val) =>
        String(val ?? '')
          .toLowerCase()
          .includes(searchValue),
      ),
    )

    setFilteredData1(filtered)
    setTotalEntries1(filtered.length)
    setCurrentPage1(1)
  }

  //==========Pagination=======================
  const handlePageSizeChange1 = (value) => {
    setPageSize1(value)
  }

  //======Search data from outside (first) table===============
  const handleSearch2 = (value) => {
    const searchValue = value.toLowerCase()

    const filtered = allOrderEntryFinalData.filter((item) =>
      Object.values(item).some((val) =>
        String(val ?? '')
          .toLowerCase()
          .includes(searchValue),
      ),
    )

    setFilteredData2(filtered)
    setTotalEntries2(filtered.length)
    setCurrentPage2(1)
  }
  //==========Pagination=======================
  const handlePageSizeChange2 = (value) => {
    setPageSize1(value)
  }

  // Fetch OrderEntry, Customer and Item Names
  let isOrderEntryFetched = false
  useEffect(() => {
    if (isOrderEntryFetched) return
    fetchLatestRate()
    fetchAlloy()
    fetchCustomer()
    fetchItemName()
    fetchTemperName()
    fetchColorCode()

    fetchOrderEntryData()
    isOrderEntryFetched = true
  }, [])

  // ==============Get table data================

  let isError = false

  const fetchOrderEntryTempData = async (orderNumberIdForTemp) => {
    try {
      const response = await axios.get(
        `${GetOrderEntrySecondById}?orderNumberId=${orderNumberIdForTemp}`,
        commonHeaders1,
      )
      if (response.data !== null) {
        setAllOrderEntryTempData(response.data)
        setFilteredData(response.data)
        setTotalEntries(response.data.length)
      }
    } catch (error) {
      if (!isError) {
        console.error('Error fetching Order Entry:', error)
        toast.error('Failed to fetch Order Entry data')
        isError = true
      }
    }
  }

  const columns = [
    {
      title: 'Sr.No.',
      dataIndex: '',
      key: 'index',
      render: (text, record, index) => (currentPage - 1) * pageSize + index + 1,
    },
    {
      title: 'Item Name',
      dataIndex: 'dieName',
      key: 'dieName',
      sorter: (a, b) =>
        String(a.dieName ?? '').localeCompare(String(b.dieName ?? '')),
    },
    {
      title: 'Alloy',
      dataIndex: 'alloyname',
      key: 'alloyname',
      sorter: (a, b) =>
        String(a.alloyname ?? '').localeCompare(String(b.alloyname ?? '')),
    },
    {
      title: 'Temp',
      dataIndex: 'temperName',
      key: 'temperName',
      sorter: (a, b) =>
        String(a.temperName ?? '').localeCompare(String(b.temperName ?? '')),
    },
    {
      title: 'Length',
      dataIndex: 'length',
      key: 'length',
      sorter: (a, b) => (a.length ?? 0) - (b.length ?? 0),
    },
    {
      title: 'Pcs',
      dataIndex: 'pcs',
      key: 'pcs',
      sorter: (a, b) => (a.pcs ?? 0) - (b.pcs ?? 0),
    },
    {
      title: 'Wtr',
      dataIndex: 'weightRange',
      key: 'weightRange',
      sorter: (a, b) =>
        String(a.weightRange ?? '').localeCompare(String(b.weightRange ?? '')),
    },
    {
      title: 'Qty (Kgs)',
      dataIndex: 'qty',
      key: 'qty',
      sorter: (a, b) => (a.qty ?? 0) - (b.qty ?? 0),
    },
    {
      title: 'Basic Rate',
      dataIndex: 'basicOrderRate',
      key: 'basicOrderRate',
      sorter: (a, b) => (a.basicOrderRate ?? 0) - (b.basicOrderRate ?? 0),
    },
    {
      title: 'Packing Rate',
      dataIndex: 'packingRate',
      key: 'packingRate',
      sorter: (a, b) => (a.packingRate ?? 0) - (b.packingRate ?? 0),
    },
    {
      title: 'Premium',
      dataIndex: 'premium',
      key: 'premium',
      sorter: (a, b) => (a.premium ?? 0) - (b.premium ?? 0),
    },
    {
      title: 'Total Rate',
      dataIndex: 'totalRate',
      key: 'totalRate',
      sorter: (a, b) => (a.totalRate ?? 0) - (b.totalRate ?? 0),
    },
    {
      title: 'Actions',
      key: 'actions',
      render: (text, record) => (
        <div>
          <span
            type="submit"
            style={{ fontSize: '12px', color: '#349ff3', marginRight: '10px' }}
            onClick={() => handleOrderDetailsEditDataButton(record)}
          >
            <i className="fa-solid fa-pen-to-square"></i>
          </span>
          <span
            type="submit"
            style={{ fontSize: '12px', color: 'red', marginLeft: '10px' }}
            onClick={() => handleOrderDetailsDeleteData(record)}
          >
            <i className="fa-solid fa-trash"></i>
          </span>
        </div>
      ),
    },
  ]

  const components = {
    header: {
      cell: ({ children, ...restProps }) => (
        <th
          {...restProps}
          style={{
            backgroundColor: '#023E7D',
            color: '#fff',
            padding: '10px',
            fontSize: '15px',
            borderRadius: '0px',
          }}
        >
          {children}
        </th>
      ),
    },
    body: {
      row: ({ children, ...restProps }) => (
        <tr
          {...restProps}
          style={{
            backgroundColor: '#f0f7fd',
          }}
        >
          {children}
        </tr>
      ),
      cell: ({ children, ...restProps }) => (
        <td
          {...restProps}
          style={{
            padding: '8px',
            fontSize: '15px',
          }}
        >
          {children}
        </td>
      ),
    },
  }

  const fetchOrderEntryFinalData = async (orderNumberId) => {
    try {
      let response

      if (orderNumberId) {
        // Call the EDIT API with params
        response = await axios.get(
          `${GetOrderEntryThirdById}?orderNumberId=${orderNumberId}`,
          commonHeaders1,
        )
      }
      if (response.data == 'NOTFOUND') {
        toast.warn('Data not found!!')
      } else if (response.data !== null) {
        setAllOrderEntryFinalData(response.data)
        setFilteredData1(response.data)
        setTotalEntries1(response.data.length)
      }
    } catch (error) {
      if (!isError) {
        console.error('Error fetching Order Entry Final:', error)
        toast.error('Failed to fetch Order Entry Final data')
        isError = true
      }
    }
  }

  const columns1 = [
    {
      title: 'Sr.No.',
      dataIndex: 'index',
      key: 'index',
      render: (text, record, index) =>
        (currentPage1 - 1) * pageSize1 + index + 1,
    },
    {
      title: 'Item Name',
      dataIndex: 'dieName',
      key: 'dieName',
      sorter: (a, b) =>
        String(a.dieName ?? '').localeCompare(String(b.dieName ?? '')),
    },
    {
      title: 'Alloy',
      dataIndex: 'alloyname',
      key: 'alloyname',
      sorter: (a, b) =>
        String(a.alloyname ?? '').localeCompare(String(b.alloyname ?? '')),
    },
    {
      title: 'Temp',
      dataIndex: 'temperName',
      key: 'temperName',
      sorter: (a, b) =>
        String(a.temperName ?? '').localeCompare(String(b.temperName ?? '')),
    },
    {
      title: 'Length',
      dataIndex: 'length',
      key: 'length',
      sorter: (a, b) => (a.length ?? 0) - (b.length ?? 0),
    },
    {
      title: 'Pcs',
      dataIndex: 'pcs',
      key: 'pcs',
      sorter: (a, b) => (a.pcs ?? 0) - (b.pcs ?? 0),
    },
    {
      title: 'Wtr',
      dataIndex: 'weightRange',
      key: 'weightRange',
      sorter: (a, b) =>
        String(a.weightRange ?? '').localeCompare(String(b.weightRange ?? '')),
    },
    {
      title: 'Qty (Kgs)',
      dataIndex: 'qty',
      key: 'qty',
      sorter: (a, b) => (a.qty ?? 0) - (b.qty ?? 0),
    },
    {
      title: 'Basic Rate',
      dataIndex: 'basicOrderRate',
      key: 'basicOrderRate',
      sorter: (a, b) => (a.basicOrderRate ?? 0) - (b.basicOrderRate ?? 0),
    },
    {
      title: 'Packing Rate',
      dataIndex: 'packingRate',
      key: 'packingRate',
      sorter: (a, b) => (a.packingRate ?? 0) - (b.packingRate ?? 0),
    },
    {
      title: 'Premium',
      dataIndex: 'premium',
      key: 'premium',
      sorter: (a, b) => (a.premium ?? 0) - (b.premium ?? 0),
    },
    {
      title: 'Total Rate',
      dataIndex: 'totalRate',
      key: 'totalRate',
      sorter: (a, b) => (a.totalRate ?? 0) - (b.totalRate ?? 0),
    },
    {
      title: 'Actions',
      key: 'actions',
      render: (text, record) => (
        <div>
          <span
            type="submit"
            style={{ fontSize: '12px', color: 'red', marginLeft: '10px' }}
            onClick={() => handleFinalDeleteData(record)}
          >
            <i className="fa-solid fa-trash"></i>
          </span>
        </div>
      ),
    },
  ]

  const components1 = {
    header: {
      cell: ({ children, ...restProps }) => (
        <th
          {...restProps}
          style={{
            backgroundColor: '#023E7D',
            color: '#fff',
            padding: '10px',
            fontSize: '15px',
            borderRadius: '0px',
          }}
        >
          {children}
        </th>
      ),
    },
    body: {
      row: ({ children, ...restProps }) => (
        <tr
          {...restProps}
          style={{
            backgroundColor: '#f0f7fd',
          }}
        >
          {children}
        </tr>
      ),
      cell: ({ children, ...restProps }) => (
        <td
          {...restProps}
          style={{
            padding: '8px',
            fontSize: '15px',
          }}
        >
          {children}
        </td>
      ),
    },
  }

  const fetchOrderEntryData = async () => {
    try {
      const response = await axios.get(GetOrderEntry, commonHeaders)
      if (response.data !== null) {
        setAllOrderEntryFinalData(response.data)
        setFilteredData2(response.data)
        setTotalEntries2(response.data.length)
      }
    } catch (error) {
      if (!isError) {
        console.error('Error fetching Order Entry:', error)
        toast.error('Failed to fetch Order Entry data')
        isError = true
      }
    }
  }

  const columns2 = [
    {
      title: 'Sr.No.',
      dataIndex: '',
      key: 'index',
      render: (text, record, index) =>
        (currentPage2 - 1) * pageSize2 + index + 1,
    },
    {
      title: 'Order No',
      dataIndex: 'orderNumber',
      key: 'orderNumber',
      sorter: (a, b) =>
        String(a.orderNumber ?? '').localeCompare(String(b.orderNumber ?? '')),
    },
    {
      title: 'Order Dt',
      dataIndex: 'entryDate',
      key: 'entryDate',
      sorter: (a, b) => new Date(a.entryDate) - new Date(b.entryDate),
    },
    {
      title: 'PO No',
      dataIndex: 'poNumber',
      key: 'poNumber',
      sorter: (a, b) =>
        String(a.poNumber ?? '').localeCompare(String(b.poNumber ?? '')),
    },
    {
      title: 'PO Dt',
      dataIndex: 'poDate',
      key: 'poDate',
      sorter: (a, b) => new Date(a.poDate) - new Date(b.poDate),
    },
    {
      title: 'Customer Name',
      dataIndex: 'customerName',
      key: 'customerName',
      sorter: (a, b) =>
        String(a.customerName ?? '').localeCompare(
          String(b.customerName ?? ''),
        ),
    },
    {
      title: 'Customer Instru.',
      dataIndex: 'customerInstruction',
      key: 'customerInstruction',
      sorter: (a, b) =>
        String(a.customerInstruction ?? '').localeCompare(
          String(b.customerInstruction ?? ''),
        ),
    },
    {
      title: 'Packing Remark',
      dataIndex: 'packingRemark',
      key: 'packingRemark',
      sorter: (a, b) =>
        String(a.packingRemark ?? '').localeCompare(
          String(b.packingRemark ?? ''),
        ),
    },
    {
      title: 'Packing Rate',
      dataIndex: 'packingRate',
      key: 'packingRate',
      render: (text) => <div style={{ textAlign: 'right' }}>{text}</div>,
      sorter: (a, b) => (a.packingRate ?? 0) - (b.packingRate ?? 0),
    },
    {
      title: 'Basic Order Rate',
      dataIndex: 'basicOrderRate',
      key: 'basicOrderRate',
      render: (text) => <div style={{ textAlign: 'right' }}>{text}</div>,
      sorter: (a, b) => (a.basicOrderRate ?? 0) - (b.basicOrderRate ?? 0),
    },
    {
      title: 'Total Qty (kgs)',
      dataIndex: 'totalQty',
      key: 'totalQty',
      render: (text) => <div style={{ textAlign: 'right' }}>{text}</div>,
      sorter: (a, b) => (a.totalQty ?? 0) - (b.totalQty ?? 0),
    },
    {
      title: 'Dispatch Qty',
      dataIndex: 'dispatchQty',
      key: 'dispatchQty',
      render: (text) => <div style={{ textAlign: 'right' }}>{text}</div>,
      sorter: (a, b) => (a.dispatchQty ?? 0) - (b.dispatchQty ?? 0),
    },
    {
      title: 'Ready Qty',
      dataIndex: 'readyQty',
      key: 'readyQty',
      render: (text) => <div style={{ textAlign: 'right' }}>{text}</div>,
      sorter: (a, b) => (a.readyQty ?? 0) - (b.readyQty ?? 0),
    },
    {
      title: 'Pending Qty',
      dataIndex: 'pendingQty',
      key: 'pendingQty',
      render: (text) => <div style={{ textAlign: 'right' }}>{text}</div>,
      sorter: (a, b) => (a.pendingQty ?? 0) - (b.pendingQty ?? 0),
    },
    {
      title: 'Actions',
      key: 'actions',
      render: (text, record) => (
        <div
          className="text-center d-flex"
          style={{ justifyContent: 'space-between' }}
        >
          <span type="submit" onClick={() => handleEditData(record)}>
            <i
              class="fa-solid fa-plus"
              title="Add"
              style={{
                color: 'white',
                backgroundColor: 'black',
                borderRadius: '50px',
                padding: '2px',
              }}
            ></i>
          </span>
          <span type="submit" onClick={() => handleEditCustomerData(record)}>
            <i
              class="fa-solid fa-file-pen"
              title="Edit"
              style={{ color: 'orange' }}
            ></i>
          </span>
          {/* <span
          type="submit"
          style={{ fontSize: "12px", color: "white", backgroundColor: "red", borderRadius: "5px", padding: "3px 6px",margin:"2px" }}
          onClick={() => handleDeleteData(record)}
        >
          Close
        </span> */}
        </div>
      ),
    },
    {
      title: 'Close',
      key: 'close',
      render: (text, record) => (
        <div className="text-center" style={{ justifyContent: 'space-evenly' }}>
          <span
            type="submit"
            style={{
              fontSize: '12px',
              color: 'white',
              backgroundColor: 'red',
              borderRadius: '5px',
              padding: '3px 6px',
              margin: '2px',
            }}
            onClick={() => handleDeleteData(record)}
          >
            Close
          </span>
        </div>
      ),
    },
  ]

  const components2 = {
    header: {
      cell: ({ children, ...restProps }) => (
        <th
          {...restProps}
          style={{
            backgroundColor: '#023E7D',
            color: '#fff',
            padding: '10px',
            fontSize: '15px',
            borderRadius: '0px',
          }}
        >
          {children}
        </th>
      ),
    },
    body: {
      row: ({ children, ...restProps }) => (
        <tr
          {...restProps}
          style={{
            backgroundColor: '#f0f7fd',
          }}
        >
          {children}
        </tr>
      ),
      cell: ({ children, ...restProps }) => (
        <td
          {...restProps}
          style={{
            padding: '8px',
            fontSize: '15px',
          }}
        >
          {children}
        </td>
      ),
    },
  }

  const fetchAlloy = async () => {
    try {
      const response = await axios.get(GetAlloyMaster, commonHeaders)
      if (response.data !== null) {
        setAllAlloy(response.data)
      }
    } catch (error) {
      if (!isError) {
        console.error('Error fetching Alloy:', error)
        toast.error('Failed to fetch Alloy data')
        isError = true // Set the flag to prevent double toast
      }
    }
  }
  const fetchCustomer = async () => {
    try {
      const response = await axios.get(GetCustomerMaster, commonHeaders)
      if (response.data !== null) {
        setAllCustomers(response.data)
      }
    } catch (error) {
      if (!isError) {
        console.error('Error fetching Customers:', error)
        toast.error('Failed to fetch Customers data')
        isError = true // Set the flag to prevent double toast
      }
    }
  }

  const fetchItemName = async () => {
    try {
      const response = await axios.get(DieNameMasterGet, commonHeaders)
      if (response.data !== null) {
        setAllItems(response.data)
      }
    } catch (error) {
      if (!isError) {
        console.error('Error fetching Item:', error)
        toast.error('Failed to fetch Item data')
        isError = true // Set the flag to prevent double toast
      }
    }
  }
  const fetchTemperName = async () => {
    try {
      const response = await axios.get(TemperMasterGet, commonHeaders)
      if (response.data !== null) {
        setAllTemper(response.data)
      }
    } catch (error) {
      if (!isError) {
        console.error('Error fetching Temper:', error)
        toast.error('Failed to fetch Temper data')
        isError = true // Set the flag to prevent double toast
      }
    }
  }

  const fetchLatestRate = async () => {
    try {
      const response = await axios.get(getLatestRate, commonHeaders1)
      if (response.data !== null) {
        setNalcoRate(response.data.nalcoRate)
        setSixtyThreeRate(response.data.rate6063)
        setCommercialRate(response.data.commercialRate)
        setE91ERate(response.data.rateE91E)
      }
    } catch (error) {
      if (!isError) {
        console.error('Error fetching Item:', error)
        toast.error('Failed to fetch Item data')
        isError = true // Set the flag to prevent double toast
      }
    }
  }
  const fetchColorCode = async () => {
    try {
      const response = await axios.get(GetColorCode, commonHeaders1)
      if (response.data !== null) {
        setColorOptions(response.data)
      }
    } catch (error) {
      if (!isError) {
        console.error('Error fetching Color:', error)
        toast.error('Failed to fetch Color data')
        isError = true // Set the flag to prevent double toast
      }
    }
  }

  const getTextColor = (colorCode) => {
    const whiteTextCodes = ['#ff3333', '#008000', '#0000ff']
    return whiteTextCodes.includes(colorCode.toLowerCase()) ? '#fff' : '#000'
  }

  //====================================================

  const handleEditData = (record) => {
    const orderNumberId = record.orderNumberId
    setOrderNumberIdForTemp(orderNumberId)
    fetchOrderEntryFinalData(orderNumberId)

    setShowOrderDetails(true)
    setShowTable(false)
    // setShowOrderEntry(false);

    // Populate form fields with the selected record
    setOrderDetailsNumber(record.orderNumber || '')
    setCustomerNameId(record.customerNameId || '')
    setOrderDId(record.orderNumberId || '')
    setPackingDetailsRate(record.packingRate || null)
    setPremiumDetails(record.premium || null)
    setPremiumDetails1(record.premium || null)
    setBasicOrderDetailsRate(record.basicOrderRate || null)

    setOrderNumber(record.orderNumber || '')
    setOrderDate(record.entryDate || '')
    setPoNumberDetails(record.poNumber || '')
    setCustomerNameDetails(record.customerName || '')

    setErrors({})
  }

  const handleDeleteData = async (item) => {
    const confirmDelete = window.confirm(
      `Are you sure you want to delete this Order No data "${item.orderNumber}"?`,
    )
    if (!confirmDelete) return

    try {
      const response = await axios.delete(
        `${CloseOrderEntry}?id=${item.id}`,
        commonHeaders,
      )
      if (response.data === 'DELETED') {
        toast.success('Order deleted successfully!')
        fetchOrderEntryData()
      } else if (response.data === 'NOTFOUND') {
        toast.warn('Order Data Not Found!')
      }
    } catch (error) {
      console.error('Error during delete operation:', error)
      toast.error('Error occurred while deleting the Order')
    }
  }

  // /========================== ORDER DETAILS ENTRY CODE ================================/ //

  //=========CANCEL ORDER DETAILS ENTRY DATA============
  const handleOrderDetailsCancel = () => {
    setAlloy(1)
    setLengthDetails('')
    setItemName('')
    setTemper('')
    setPcs('')
    setUnit('')
    setWeightRange('')
    setQty('')
    setPremiumDetails('')
    setPremiumDetails1('')
    setTotalRate(0)

    setErrors('')
  }

  //=========SAVE ORDER DETAILS ENTRY DATA============
  const handleOrderDetailsSubmit = async () => {
    let isValid = true
    const errorObj = {}

    if (!orderDetailsNumber) {
      isValid = false
      errorObj.orderDetailsNumber = 'Order Number is required *'
    }
    if (!alloy) {
      isValid = false
      errorObj.alloy = 'Alloy is required *'
    }
    if (!lengthDetails) {
      isValid = false
      errorObj.lengthDetails = 'Length is required *'
    }
    if (!basicOrderDetailsRate) {
      isValid = false
      errorObj.basicOrderDetailsRate = 'Basic Order Rate is required *'
    }
    if (!itemName) {
      isValid = false
      errorObj.itemName = 'Item Name is required *'
    }
    if (!temper) {
      isValid = false
      errorObj.temper = 'Temper is required *'
    }
    if (!pcs) {
      isValid = false
      errorObj.pcs = 'Pcs is required *'
    }
    if (!packingDetailsRate) {
      isValid = false
      errorObj.packingDetailsRate = 'Packing Rate is required *'
    }
    if (!unit) {
      isValid = false
      errorObj.unit = 'Unit is required *'
    }
    if (!weightRange) {
      isValid = false
      errorObj.weightRange = 'Weight Range is required *'
    }
    if (!qty) {
      isValid = false
      errorObj.qty = 'Quantity is required *'
    }
    if (!premiumDetails) {
      isValid = false
      errorObj.premiumDetails = 'Premium is required *'
    }

    setErrors(errorObj) // Set error messages

    if (!isValid) return

    const formData = {
      orderNumberId: orderDId,
      alloyId: alloy,
      length: parseFloat(lengthDetails),
      basicOrderRate: parseFloat(basicOrderDetailsRate),
      dieNameId: itemName,
      temperId: temper,
      qty: parseFloat(qty),
      pcs: parseFloat(pcs),
      packingRate: parseFloat(packingDetailsRate),
      unit: parseFloat(unit),
      weightRange: parseFloat(weightRange),
      premium: parseFloat(premiumDetails),
      totalRate: '',
      customerId: customerNameId,
    }

    try {
      const response = await axios.post(
        SaveOrderEntrySecond,
        formData,
        commonHeaders,
      )
      const { orderNumber, message } = response.data

      if (message === 'CREATED') {
        toast.success('Order Details added successfully!')
        handleOrderDetailsCancel()
        fetchOrderEntryTempData(orderNumberIdForTemp)

        // Then focus the "Items Name dropdown" button
        itemNameBtnRef.current?.focus()
      } else if (response.data === 'ALREADYEXISTED') {
        toast.warn('Order Details already exist!')
      }
    } catch (error) {
      console.error('Error during API call:', error)
      toast.error('Error occurred while submitting data')
    }
  }

  //=========EDIT ORDER DETAILS ENTRY DATA============
  const handleOrderDetailsEditDataButton = (item) => {
    // Set form values based on the item clicked
    setOrderDetailsId(item.id || '')
    setOrderDetailsNumberModal(item.orderNumberId || '')
    setAlloyModal(item.alloyId || null)
    setLengthDetailsModal(item.length || '')
    setBasicOrderDetailsRateModal(item.basicOrderRate || '')
    setItemNameModal(item.dieNameId || null)
    setTemperModal(item.temperId || null)
    setPcsModal(item.pcs || '')
    setPackingDetailsRateModal(item.packingRate || '')
    // setUnitModal(item.unit || null);
    setUnitModal(item.unit ? String(item.unit) : null)
    setWeightRangeModal(item.weightRange || '')
    setQtyModal(item.qty || '')
    setPremiumDetailsModal(item.premium || '')
    setTotalRateModal(item.totalRate || '')

    // Other non-editable fields for display
    setOrderNumberModal(item.orderNumber || '')
    setOrderDateModal(item.poDate || '')
    setPoNumberDetailsModal(item.poNumber || '')
    setCustomerNameDetailsModal(item.customerName || '')
    setCustomerNameIdModal(item.customerId || '')

    // Show modal
    setIsModalVisible(true)
  }

  //=========UPDATE ORDER DETAILS ENTRY DATA============
  const handleOrderDetailsUpdate = async () => {
    const formData = {
      id: orderDetailsId,
      orderNumberId: orderDetailsNumberModal,
      alloyId: alloyModal,
      length: parseFloat(lengthDetailsModal),
      basicOrderRate: parseFloat(basicOrderDetailsRateModal),
      dieNameId: itemNameModal,
      temperId: temperModal,
      pcs: parseFloat(pcsModal),
      qty: parseFloat(qtyModal),
      packingRate: parseFloat(packingDetailsRateModal),
      unit: parseFloat(unitModal),
      weightRange: parseFloat(weightRangeModal),
      premium: parseFloat(premiumDetailsModal),
      totalRate: '',
      customerId: customerNameIdModal,
    }

    try {
      const response = await axios.put(
        UpdateOrderEntrySecond,
        formData,
        commonHeaders,
      )

      if (response.data === 'UPDATED') {
        toast.success('Order Details updated successfully!')
        setIsModalVisible(false)
        fetchOrderEntryTempData(orderNumberIdForTemp)
      } else if (response.data === 'ALREADYEXISTED') {
        toast.warn('Order Details already exist!')
      }
    } catch (error) {
      console.error('Error during API call:', error)
      toast.error('Error occurred while updating data')
    }
  }

  //=========DELETE ORDER DETAILS ENTRY DATA============
  const handleOrderDetailsDeleteData = async (item) => {
    const confirmDelete = window.confirm(
      `Are you sure you want to delete this Item data "${item.dieName}"?`,
    )
    if (!confirmDelete) return

    try {
      const response = await axios.delete(
        `${DeleteOrderEntrySecond}?id=${item.id}`,
        commonHeaders,
      )
      if (response.data === 'DELETED') {
        toast.success('Order deleted successfully!')
        fetchOrderEntryTempData(orderNumberIdForTemp)
      } else if (response.data === 'NOTFOUND') {
        toast.warn('Order Data Not Found!')
      }
    } catch (error) {
      console.error('Error during delete operation:', error)
      toast.error('Error occurred while deleting the Order')
    }
  }

  // /========================== FINAL ENTRY CODE ================================/ //

  //=========CANCEL ORDER FINAL ENTRY DATA============
  const handleSubmit = () => {
    setFilteredData1([])
    setFilteredData2([])
    setAllOrderEntryFinalData([])
    setAllOrderEntryTempData([])
    fetchOrderEntryData()

    setShowOrderDetails(false)
    // setShowOrderEntry(false);
    setShowTable(true)
  }
  const handleCancel = () => {
    // setShowOrderEntry(true)
    setShowTable(true)
    setShowOrderDetails(false)
  }

  //=========SAVE ORDER FINAL ENTRY DATA============
  const handleFinalSubmit = async () => {
    try {
      const response = await axios.post(
        SaveOrderEntryThird,
        null,
        commonHeaders,
      )
      const { orderNumberId, message } = response.data
      if (message === 'MOVED') {
        fetchOrderEntryFinalData(orderNumberId)
        fetchOrderEntryTempData(orderNumberIdForTemp)
        // handleFinalCancel();
      }
    } catch (error) {
      console.error('Error during API call:', error)
      toast.error('Error occurred while submitting data')
    }
  }

  //=========DELETE ORDER FINAL ENTRY DATA============
  const handleFinalDeleteData = async (item) => {
    const confirmDelete = window.confirm(
      `Are you sure you want to delete this Item "${item.dieName}"?`,
    )
    if (!confirmDelete) return

    try {
      const response = await axios.delete(
        `${DeleteOrderEntryThird}?id=${item.id}`,
        commonHeaders1,
      )
      if (response.data === 'DELETED') {
        fetchOrderEntryFinalData(item.orderNumberId)
        toast.success('Order deleted successfully!')
      }
      if (response.data === 'NOTFOUND') {
        toast.warn('Order not found!')
      }
    } catch (error) {
      console.error('Error during delete operation:', error)
      toast.error('Error occurred while deleting the Order')
    }
  }

  //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
  ///===img file=======
  // const handleFileChangeModal = (e) => {
  //   const file = e.target.files[0] // Get the selected file

  //   // Check if the file size exceeds 1 MB (1 MB = 1048576 bytes)
  //   if (file && file.size > 1048576) {
  //     alert('File size exceeds 1 MB. Please select a smaller file.')
  //     return // Stop further processing
  //   }

  //   setAttachPOFile(file) // Store the selected file in the state

  //   // // Generate the preview URL
  //   if (file) {
  //     const previewUrl = URL.createObjectURL(file)
  //     setPrevImgModal(previewUrl) // Store the preview URL in the state
  //   }
  // }
  // const fileInputRef = useRef(null)
  //=====================
  const dateFormatList = ['DD/MM/YYYY', 'DD/MM/YY', 'DD-MM-YYYY', 'DD-MM-YY']

  const goodTypesOptions = [
    { value: '1', label: 'Ft' },
    { value: '2', label: 'MM' },
    { value: '3', label: 'Inch' },
  ]

  //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~

  useEffect(() => {
    const length = parseFloat(lengthDetails)
    const range = parseFloat(weightRange)
    const pcsCount = parseFloat(pcs)

    if (!isNaN(length) && !isNaN(range) && !isNaN(pcsCount)) {
      let calculatedQty = 0

      if (unit == '1') {
        calculatedQty = range * (length / 12) * pcsCount
      } else if (unit == '2') {
        calculatedQty = range * (length / 3660) * pcsCount
      } else if (unit == '3') {
        calculatedQty = range * (length / 144) * pcsCount
      }

      // Round to 2 decimal places if needed
      setQty(calculatedQty.toFixed(2))
    } else {
      setQty('') // Clear if input is invalid
    }
  }, [unit, weightRange, lengthDetails, pcs])

  //=====for modal==========
  useEffect(() => {
    const lengthModal = parseFloat(lengthDetailsModal)
    const rangeModal = parseFloat(weightRangeModal)
    const pcsCountModal = parseFloat(pcsModal)

    if (!isNaN(lengthModal) && !isNaN(rangeModal) && !isNaN(pcsCountModal)) {
      let calculatedQtyModal = 0

      if (unitModal == '1') {
        calculatedQtyModal = rangeModal * (lengthModal / 12) * pcsCountModal
      } else if (unitModal == '2') {
        calculatedQtyModal = rangeModal * (lengthModal / 3660) * pcsCountModal
      } else if (unitModal == '3') {
        calculatedQtyModal = rangeModal * (lengthModal / 144) * pcsCountModal
      }

      // Round to 2 decimal places if needed
      setQtyModal(calculatedQtyModal.toFixed(2))
    } else {
      setQtyModal('') // Clear if input is invalid
    }
  }, [unitModal, weightRangeModal, lengthDetailsModal, pcsModal])

  useEffect(() => {
    const basicRate = parseFloat(basicOrderDetailsRate)
    const packingRate = parseFloat(packingDetailsRate)
    const premium = parseFloat(premiumDetails)

    if (!isNaN(basicRate) && !isNaN(packingRate) && !isNaN(premium)) {
      const total = basicRate + packingRate + premium
      setTotalRate(total.toFixed(2))
    } else {
      setTotalRate(0) // or setTotalRate(null);
    }
  }, [basicOrderDetailsRate, packingDetailsRate, premiumDetails])

  // ===for modal==============
  useEffect(() => {
    const basicRate = parseFloat(basicOrderDetailsRateModal)
    const packingRate = parseFloat(packingDetailsRateModal)
    const premium = parseFloat(premiumDetailsModal)

    if (!isNaN(basicRate) && !isNaN(packingRate) && !isNaN(premium)) {
      const total = basicRate + packingRate + premium
      setTotalRateModal(total.toFixed(2))
    } else {
      setTotalRateModal(0) // or setTotalRateModal(null);
    }
  }, [basicOrderDetailsRateModal, packingDetailsRateModal, premiumDetailsModal])

  //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~

  const handleItemChange = (value) => {
    setItemName(value)

    const selectedItem = allItems.find((item) => item.id === value)
    if (selectedItem) {
      const updatedPremiumDetails = selectedItem.diePreminium
      setPremiumDetails(updatedPremiumDetails)
      setPremiumDetails1(updatedPremiumDetails)
    }
  }
  //======================================================

  return (
    <>
      <div className="p-0 m-0">
        {/*================ Outside Table (first)=========================*/}
        {showTable && (
          <>
            <div className="px-5 py-3">
              <div
                className="row mt-3 p-3 py-5  rounded"
                style={{ backgroundColor: '#e0efff' }}
              >
                <div className="col-12 text-start"></div>
                <div
                  className="col-12 py-3 shadow border rounded"
                  style={{ backgroundColor: 'white' }}
                >
                  {/* <div className="row ps-2 m-0 mb-2">
                        <div className="col-12 col-md-3 col-lg-1">
                          <Button
                            onClick={handleShowForm}
                            style={{ backgroundColor: '#f8bf28' }}
                          >
                            Add Order Entry +
                          </Button>
                        </div>
                        <div className="col-12 col-md-9 col-lg-11"></div>
                      </div> */}

                  <div
                    className="col-12 px-lg-5"
                    style={{ display: 'flex', justifyContent: 'space-between' }}
                  >
                    <div>
                      <span style={{ fontSize: '14px' }}>
                        Show entries &nbsp;
                      </span>
                      <Select
                        defaultValue={pageSize2}
                        onChange={handlePageSizeChange2}
                        style={{ width: 120, textAlign: 'center' }}
                      >
                        <Option value={10}>10</Option>
                        <Option value={20}>20</Option>
                        <Option value={30}>30</Option>
                      </Select>
                    </div>

                    <div className="pt-4 pt-lg-0">
                      <Input.Search
                        placeholder="Search"
                        // onSearch={handleSearch2}
                        onChange={(e) => handleSearch2(e.target.value)}
                        style={{ width: 200, marginBottom: 16 }}
                      />
                    </div>
                  </div>

                  <div style={{ backgroundColor: 'white' }}>
                    <Table
                      bordered
                      style={{ padding: '0px 20px', overflowX: 'auto' }}
                      columns={columns2}
                      dataSource={filteredData2}
                      pagination={{
                        pageSize: pageSize2,
                        total: totalEntries2,
                        showTotal: (total, range) =>
                          `Showing ${range[0]} to ${range[1]} of ${total} entries`,
                        current: currentPage2,
                        onChange: (page) => setCurrentPage2(page),
                      }}
                      showSorterTooltip={false}
                      rowKey={(record) => record.id}
                      components={components2}
                    />
                  </div>
                </div>
              </div>
            </div>

            <Modal
              title="Edit Customer Order"
              open={isCustomerModalVisible}
              onCancel={() => setIsCustomerModalVisible(false)}
              footer={null}
              width={800}
            >
              <div className="col-12">
                <div className="row p-0 m-0">
                  <div className="col-lg-12 py-1">
                    <label className="labels">Customer Name</label>
                    <Select
                      value={customerNameEdit || undefined}
                      onChange={(value) => {
                        setCustomerNameEdit(value)
                      }}
                      showSearch
                      className="w-100"
                      placeholder="Select Name"
                      optionFilterProp="children"
                    >
                      {allCustomers.map((customer) => (
                        <Option key={customer.id} value={customer.id}>
                          {customer.customerName}
                        </Option>
                      ))}
                    </Select>
                    {errors.customerNameEdit && (
                      <div className="errorField">
                        {errors.customerNameEdit}
                      </div>
                    )}
                  </div>

                  <div className="col-lg-8 py-1">
                    <label className="labels">PO Number</label>
                    <Input
                      value={poNumberEdit}
                      onChange={(e) => setPoNumberEdit(e.target.value)}
                      placeholder="Enter Number"
                      maxLength={250}
                    />
                    {errors.poNumberEdit && (
                      <div className="errorField">{errors.poNumberEdit}</div>
                    )}
                  </div>

                  <div className="col-lg-4 py-1">
                    <label className="labels">PO Date</label>
                    <DatePicker
                      className="w-100"
                      format={dateFormatList}
                      value={poDateEdit}
                      onChange={(value) => setPoDateEdit(value)}
                    />
                    {errors.poDateEdit && (
                      <div className="errorField">{errors.poDateEdit}</div>
                    )}
                  </div>

                  <div className="col-lg-12 py-1">
                    <label className="labels">Customer Instruction</label>
                    <Input.TextArea
                      value={customerInstructionEdit}
                      onChange={(e) =>
                        setCustomerInstructionEdit(e.target.value)
                      }
                      placeholder="Enter Instruction"
                      maxLength={250}
                    />
                    {errors.customerInstructionEdit && (
                      <div className="errorField">
                        {errors.customerInstructionEdit}
                      </div>
                    )}
                  </div>

                  <div className="col-lg-12 py-1">
                    <label className="labels">Packing Remark</label>
                    <Input.TextArea
                      value={packingRemarkEdit}
                      onChange={(e) => setPackingRemarkEdit(e.target.value)}
                      placeholder="Enter Remark"
                      maxLength={250}
                    />
                    {errors.packingRemarkEdit && (
                      <div className="errorField">
                        {errors.packingRemarkEdit}
                      </div>
                    )}
                  </div>

                  <div className="col-lg-6 py-1">
                    <label className="labels">Basic Order Rate</label>
                    <Input
                      type="number"
                      value={basicOrderEntryRateEdit}
                      onChange={(e) =>
                        setBasicOrderEntryRateEdit(e.target.value)
                      }
                      placeholder="Enter Rate"
                      maxLength={250}
                    />
                    {errors.basicOrderEntryRateEdit && (
                      <div className="errorField">
                        {errors.basicOrderEntryRateEdit}
                      </div>
                    )}
                  </div>

                  <div className="col-lg-6 py-1">
                    <label className="labels">Packing Rate</label>
                    <Input
                      type="number"
                      value={packingEntryRateEdit}
                      onChange={(e) => setPackingEntryRateEdit(e.target.value)}
                      placeholder="Enter Rate"
                      maxLength={250}
                    />
                    {errors.packingEntryRateEdit && (
                      <div className="errorField">
                        {errors.packingEntryRateEdit}
                      </div>
                    )}
                  </div>

                  <div className="col-lg-6 py-1">
                    <label className="labels">Color Code</label>
                    <Select
                      placeholder="Select Color"
                      value={colorCodeEdit}
                      onChange={(value) => setColorCodeEdit(value)}
                      style={{ width: '100%' }}
                      dropdownStyle={{ maxHeight: 300, overflow: 'auto' }}
                      showSearch
                      optionLabelProp="label"
                    >
                      <Option value="">Select Color</Option>
                      {colorOptions.map((color) => (
                        <Option
                          key={color.id}
                          value={color.id}
                          label={color.name}
                        >
                          <div
                            style={{
                              backgroundColor: color.code,
                              padding: '5px 10px',
                              color: getTextColor(color.code),
                              borderRadius: '4px',
                              border: '1px solid #e9e9e9',
                            }}
                          >
                            {color.name}
                          </div>
                        </Option>
                      ))}
                    </Select>

                    {errors.colorCodeEdit && (
                      <div className="errorField">{errors.colorCodeEdit}</div>
                    )}
                  </div>

                  <div className="col-lg-6 py-1">
                    <label className="labels">Sticker Code</label>
                    <Input
                      value={stickerCodeEdit}
                      onChange={(e) => setStickerCodeEdit(e.target.value)}
                      placeholder="Enter Sticker"
                      maxLength={250}
                    />
                    {errors.stickerCodeEdit && (
                      <div className="errorField">{errors.stickerCodeEdit}</div>
                    )}
                  </div>
                </div>
              </div>

              <div className="row p-0 m-0">
                <div className="col-12 text-center pt-3">
                  <Button
                    className="CancelBtn mx-1"
                    onClick={() => setIsCustomerModalVisible(false)}
                  >
                    Cancel
                  </Button>
                  <Button
                    className="UpdateBtn mx-1"
                    type="primary"
                    onClick={handleOrderEntryCustomerUpdate}
                  >
                    Update Order Entry
                  </Button>
                </div>
              </div>
            </Modal>
          </>
        )}

        {showOrderDetails && (
          <div className="px-5 py-3">
            <div
              className="row mt-3 p-3 py-2  rounded"
              style={{ backgroundColor: '#e0efff' }}
            >
              <div className="col-12 col-lg-12">
                <div className="row p-0 m-0">
                  <div className="col-md-6 py-1">
                    <label className="labels">Order No : {orderNumber}</label>
                  </div>
                  <div className="col-md-6 py-1">
                    <label className="labels">Order Date : {orderDate}</label>
                  </div>
                  <div className="col-md-6 py-1">
                    <label className="labels">PO No : {poNumberDetails}</label>
                  </div>
                  <div className="col-md-6 py-1">
                    <label className="labels">
                      Customer Name : {customerNameDetails}
                    </label>
                  </div>
                  {/* <div className="col-md-6 py-1 pb-3">
                      <label className="labels">Premium Rate : {premiumDetails || 0}</label>
              </div>  */}
                  <div
                    className="col-12 mb-2"
                    style={{ borderBottom: '1px solid grey' }}
                  ></div>

                  <div className="col-12 col-lg-10">
                    <div className="row p-0 m-0">
                      <div className="col-md-6 col-lg-4 py-1">
                        <label className="labels">Item Name</label>
                        <Select
                          ref={itemNameBtnRef}
                          value={itemName || undefined}
                          onChange={handleItemChange}
                          showSearch
                          className="w-100"
                          placeholder="Select Name"
                          optionFilterProp="children"
                        >
                          {allItems.map((item) => (
                            <Option key={item.id} value={item.id}>
                              {item.dieName}
                            </Option>
                          ))}
                        </Select>
                        {errors.itemName && (
                          <div className="errorField">{errors.itemName}</div>
                        )}
                      </div>

                      <div className="col-md-6 col-lg-4 py-1">
                        <label className="labels">Alloy</label>
                        <Select
                          value={alloy || undefined}
                          onChange={setAlloy}
                          showSearch
                          className="w-100"
                          placeholder="Select Name"
                          optionFilterProp="children"
                        >
                          {allAlloy.map((alloy) => (
                            <Option key={alloy.id} value={alloy.id}>
                              {alloy.alloyName}
                            </Option>
                          ))}
                        </Select>
                        {errors.alloy && (
                          <div className="errorField">{errors.alloy}</div>
                        )}
                      </div>

                      <div className="col-md-6 col-lg-4 py-1">
                        <label className="labels">Temper</label>
                        <Select
                          value={temper || undefined}
                          onChange={setTemper}
                          showSearch
                          className="w-100"
                          placeholder="Select Temper"
                          optionFilterProp="children"
                        >
                          {allTemper.map((temper) => (
                            <Option key={temper.id} value={temper.id}>
                              {temper.temperName}
                            </Option>
                          ))}
                        </Select>
                        {errors.temper && (
                          <div className="errorField">{errors.temper}</div>
                        )}
                      </div>

                      <div className="col-md-6 col-lg-4 py-1">
                        <label className="labels">Weight Range (12ft)</label>
                        <Input
                          type="number"
                          value={weightRange}
                          onChange={(e) => setWeightRange(e.target.value)}
                          placeholder="Enter Range"
                          maxLength={250}
                        />
                        {errors.weightRange && (
                          <div className="errorField">{errors.weightRange}</div>
                        )}
                      </div>

                      <div className="col-md-6 col-lg-4 py-1">
                        <label className="labels">Length</label>
                        <Input
                          type="number"
                          value={lengthDetails}
                          onChange={(e) => setLengthDetails(e.target.value)}
                          placeholder="Enter Length"
                          maxLength={250}
                        />
                        {errors.lengthDetails && (
                          <div className="errorField">
                            {errors.lengthDetails}
                          </div>
                        )}
                      </div>

                      <div className="col-md-6 col-lg-4 py-1">
                        <label className="labels">Unit</label>
                        <Select
                          value={unit || undefined}
                          onChange={setUnit}
                          showSearch
                          className="w-100"
                          placeholder="Select Unit"
                          optionFilterProp="children"
                        >
                          {goodTypesOptions.map((opt) => (
                            <Option key={opt.value} value={opt.value}>
                              {opt.label}
                            </Option>
                          ))}
                        </Select>
                        {errors.unit && (
                          <div className="errorField">{errors.unit}</div>
                        )}
                      </div>

                      <div className="col-md-6 col-lg-4 py-1">
                        <label className="labels">Psc</label>
                        <Input
                          type="number"
                          value={pcs}
                          onChange={(e) => setPcs(e.target.value)}
                          placeholder="Enter Rate"
                          maxLength={250}
                        />
                        {errors.pcs && (
                          <div className="errorField">{errors.pcs}</div>
                        )}
                      </div>

                      <div className="col-md-6 col-lg-4 py-1">
                        <label className="labels">Qty (Kgs)</label>
                        <Input
                          value={qty}
                          onChange={(e) => setQty(e.target.value)}
                          placeholder="Qty"
                          maxLength={250}
                        />
                        {errors.qty && (
                          <div className="errorField">{errors.qty}</div>
                        )}
                      </div>

                      <div className="col-md-6 col-lg-4 py-1">
                        <label className="labels">Basic Order Rate</label>
                        <Input
                          value={basicOrderDetailsRate}
                          onChange={(e) =>
                            setBasicOrderDetailsRate(e.target.value)
                          }
                          placeholder="Enter Rate"
                          maxLength={250}
                        />
                        {errors.basicOrderDetailsRate && (
                          <div className="errorField">
                            {errors.basicOrderDetailsRate}
                          </div>
                        )}
                      </div>

                      <div className="col-md-6 col-lg-4 py-1">
                        <label className="labels">Packing Rate</label>
                        <Input
                          value={packingDetailsRate}
                          onChange={(e) =>
                            setPackingDetailsRate(e.target.value)
                          }
                          placeholder="Enter Packing Rate"
                          maxLength={250}
                        />
                        {errors.packingDetailsRate && (
                          <div className="errorField">
                            {errors.packingDetailsRate}
                          </div>
                        )}
                      </div>

                      <div className="col-md-6 col-lg-4 py-1">
                        <label className="labels">Premium</label>
                        <Input
                          type="number"
                          value={premiumDetails}
                          onChange={(e) => setPremiumDetails(e.target.value)}
                          onKeyDown={handlePremiumKeyDown}
                          placeholder="Enter Premium"
                          maxLength={250}
                        />
                        {errors.premiumDetails && (
                          <div className="errorField">
                            {errors.premiumDetails}
                          </div>
                        )}
                      </div>

                      <div className="col-md-6 col-lg-4 py-1">
                        <label className="labels">Total</label>
                        <Input
                          readOnly
                          style={{ backgroundColor: '#e9e9e9' }}
                          value={totalRate}
                          placeholder="Enter Rate"
                          maxLength={250}
                        />
                        {errors.totalRate && (
                          <div className="errorField">{errors.totalRate}</div>
                        )}
                      </div>
                    </div>
                  </div>

                  <div
                    className="col-12 col-lg-2 py-3 rounded"
                    style={{ backgroundColor: '#c0dcf7' }}
                  >
                    <div className="col-12 py-1">
                      <label className="labels">NALCO Rate</label> <br />
                      <div
                        className="w-100"
                        style={{
                          fontSize: '18px',
                          backgroundColor: '#e9e9e9e9',
                          borderRadius: '5px',
                          padding: '0px 30px',
                        }}
                      >
                        {nalcoRate}
                      </div>
                    </div>

                    <div className="col-12 py-1">
                      <label className="labels">6063 Rate</label> <br />
                      <div
                        className="w-100"
                        style={{
                          fontSize: '18px',
                          backgroundColor: '#e9e9e9e9',
                          borderRadius: '5px',
                          padding: '0px 30px',
                        }}
                      >
                        {sixtyThreeRate}
                      </div>
                    </div>

                    <div className="col-12 py-1">
                      <label className="labels">Commercial Rate</label> <br />
                      <div
                        className="w-100"
                        style={{
                          fontSize: '18px',
                          backgroundColor: '#e9e9e9e9',
                          borderRadius: '5px',
                          padding: '0px 30px',
                        }}
                      >
                        {commercialRate}
                      </div>
                    </div>

                    <div className="col-12 py-1">
                      <label className="labels">E91E Rate</label> <br />
                      <div
                        className="w-100"
                        style={{
                          fontSize: '18px',
                          backgroundColor: '#e9e9e9e9',
                          borderRadius: '5px',
                          padding: '0px 30px',
                        }}
                      >
                        {e91ERate}
                      </div>
                    </div>

                    <div className="col-12 py-1">
                      <label className="labels">Premium</label> <br />
                      <div
                        className="w-100"
                        style={{
                          fontSize: '18px',
                          backgroundColor: '#e9e9e9e9',
                          borderRadius: '5px',
                          padding: '0px 30px',
                        }}
                      >
                        {premiumDetails1 || '-'}
                      </div>
                    </div>
                  </div>
                </div>

                <div className="row p-0 m-0">
                  <div className="col-12 col-lg-6 text-start pt-3">
                    <Button
                      type="submit"
                      className="SubmitBtn mx-1"
                      onClick={handleFinalSubmit}
                    >
                      Submit All Items
                    </Button>
                  </div>
                  <div className="col-12 col-lg-6 text-center pt-3">
                    <Button
                      type="submit"
                      className="CancelBtn mx-1"
                      onClick={handleOrderDetailsCancel}
                    >
                      Cancel
                    </Button>
                    <Button
                      type="submit"
                      className="SubmitBtn mx-1"
                      ref={addToStackBtnRef}
                      onClick={handleOrderDetailsSubmit}
                    >
                      Add To Stack
                    </Button>
                  </div>
                </div>

                {/*================ Temp Table (second)=========================*/}
                <div className="row m-0 p-2 mb-5 px-md-5 pt-md-0 mt-3">
                  <div
                    className="col-12 py-3 shadow border"
                    style={{ backgroundColor: 'white' }}
                  >
                    <div
                      className="col-12 px-md-5"
                      style={{
                        display: 'flex',
                        justifyContent: 'space-between',
                      }}
                    >
                      <div>
                        <span style={{ fontSize: '14px' }}>
                          Show entries &nbsp;
                        </span>
                        <Select
                          defaultValue={pageSize}
                          onChange={handlePageSizeChange}
                          style={{ width: 120, textAlign: 'center' }}
                        >
                          <Option value={10}>10</Option>
                          <Option value={20}>20</Option>
                          <Option value={30}>30</Option>
                        </Select>
                      </div>

                      <div className="pt-4 pt-md-0">
                        <Input.Search
                          placeholder="Search"
                          // onSearch={handleSearch}
                          onChange={(e) => handleSearch(e.target.value)}
                          style={{ width: 200, marginBottom: 16 }}
                        />
                      </div>
                    </div>

                    <div style={{ backgroundColor: 'white' }}>
                      <Table
                        bordered
                        style={{ padding: '0px 20px', overflowX: 'auto' }}
                        columns={columns}
                        dataSource={filteredData}
                        pagination={{
                          pageSize: pageSize,
                          total: totalEntries,
                          showTotal: (total, range) =>
                            `Showing ${range[0]} to ${range[1]} of ${total} entries`,
                          current: currentPage,
                          onChange: (page) => setCurrentPage(page),
                        }}
                        showSorterTooltip={false}
                        rowKey={(record) => record.id}
                        components={components}
                      />
                    </div>
                  </div>
                </div>

                {/*================ Final Table (third)=========================*/}
                <div className="row m-0 p-2 mb-5 px-md-5 pt-md-0 mt-3">
                  <div className="col-12 text-start">
                    <h5 className="text-black">Final Order Item List</h5>
                  </div>
                  <div
                    className="col-12 py-3 shadow border"
                    style={{ backgroundColor: 'white' }}
                  >
                    <div
                      className="col-12 px-md-5"
                      style={{
                        display: 'flex',
                        justifyContent: 'space-between',
                      }}
                    >
                      <div>
                        <span style={{ fontSize: '14px' }}>
                          Show entries &nbsp;
                        </span>
                        <Select
                          defaultValue={pageSize1}
                          onChange={handlePageSizeChange1}
                          style={{ width: 120, textAlign: 'center' }}
                        >
                          <Option value={10}>10</Option>
                          <Option value={20}>20</Option>
                          <Option value={30}>30</Option>
                        </Select>
                      </div>

                      <div className="pt-4 pt-md-0">
                        <Input.Search
                          placeholder="Search"
                          // onSearch={handleSearch1}
                          onChange={(e) => handleSearch1(e.target.value)}
                          style={{ width: 200, marginBottom: 16 }}
                        />
                      </div>
                    </div>

                    <div style={{ backgroundColor: 'white' }}>
                      <Table
                        bordered
                        style={{ padding: '0px 20px', overflowX: 'auto' }}
                        columns={columns1}
                        dataSource={filteredData1}
                        pagination={{
                          pageSize: pageSize1,
                          total: totalEntries1,
                          showTotal: (total, range) =>
                            `Showing ${range[0]} to ${range[1]} of ${total} entries`,
                          current: currentPage1,
                          onChange: (page) => setCurrentPage1(page),
                        }}
                        showSorterTooltip={false}
                        rowKey={(record) => record.id}
                        components={components1}
                        summary={(pageData) => {
                          let totalQty = 0
                          let totalPcs = 0

                          pageData.forEach(({ qty, pcs }) => {
                            totalQty += Number(qty) || 0
                            totalPcs += Number(pcs) || 0
                          })

                          return (
                            <Table.Summary.Row
                              style={{ backgroundColor: '#e1ecf4' }}
                            >
                              <Table.Summary.Cell index={0} colSpan={5} />
                              <Table.Summary.Cell index={5}>
                                Total Pcs:{' '}
                                <span style={{ fontWeight: 'bold' }}>
                                  {totalPcs}
                                </span>
                              </Table.Summary.Cell>
                              <Table.Summary.Cell index={6} />
                              <Table.Summary.Cell index={7}>
                                Total Qty:{' '}
                                <span style={{ fontWeight: 'bold' }}>
                                  {totalQty}
                                </span>
                              </Table.Summary.Cell>
                              <Table.Summary.Cell index={8} />
                              <Table.Summary.Cell index={9} />
                              <Table.Summary.Cell index={11} />
                              <Table.Summary.Cell index={12} />
                              <Table.Summary.Cell index={13} />
                            </Table.Summary.Row>
                          )
                        }}
                      />
                    </div>
                  </div>

                  <div className="col-12 text-end mt-2">
                    <Button className="CancelBtn" onClick={handleCancel}>
                      Cancel
                    </Button>
                    <Button className="SubmitBtn" onClick={handleSubmit}>
                      Submit
                    </Button>
                  </div>
                </div>
              </div>
            </div>

            <Modal
              title="Edit Order Details"
              visible={isModalVisible}
              onCancel={() => setIsModalVisible(false)}
              footer={null}
              width={1000}
            >
              <div className="col-12 col-lg-12">
                <div className="row p-0 m-0">
                  <div className="col-md-6 py-1">
                    <label className="labels">
                      Order No : {orderNumberModal}
                    </label>
                  </div>
                  <div className="col-md-6 py-1">
                    <label className="labels">
                      Order Date : {orderDateModal}
                    </label>
                  </div>
                  <div className="col-md-6 py-1 pb-3">
                    <label className="labels">
                      PO No : {poNumberDetailsModal}
                    </label>
                  </div>
                  <div className="col-md-6 py-1 pb-3">
                    <label className="labels">
                      Customer Name : {customerNameDetailsModal}
                    </label>
                  </div>

                  <div className="col-md-6 col-lg-4 py-1">
                    <label className="labels">Order Number</label>
                    <Input
                      value={orderDetailsNumberModal}
                      onChange={(e) =>
                        setOrderDetailsNumberModal(e.target.value)
                      }
                      placeholder="Enter Number"
                      maxLength={250}
                    />
                  </div>

                  <div className="col-md-6 col-lg-4 py-1">
                    <label className="labels">Alloy</label>
                    <Select
                      value={alloyModal || undefined}
                      onChange={setAlloyModal}
                      showSearch
                      className="w-100"
                      placeholder="Select Name"
                      optionFilterProp="children"
                    >
                      {allAlloy.map((alloy) => (
                        <Option key={alloy.id} value={alloy.id}>
                          {alloy.alloyName}
                        </Option>
                      ))}
                    </Select>
                  </div>

                  <div className="col-md-6 col-lg-4 py-1">
                    <label className="labels">Length</label>
                    <Input
                      value={lengthDetailsModal}
                      onChange={(e) => setLengthDetailsModal(e.target.value)}
                      placeholder="Enter Length"
                      maxLength={250}
                    />
                  </div>

                  <div className="col-md-6 col-lg-4 py-1">
                    <label className="labels">Basic Order Details Rate</label>
                    <Input
                      type="number"
                      value={basicOrderDetailsRateModal}
                      onChange={(e) =>
                        setBasicOrderDetailsRateModal(e.target.value)
                      }
                      placeholder="Enter Rate"
                      maxLength={250}
                    />
                  </div>

                  <div className="col-md-6 col-lg-4 py-1">
                    <label className="labels">Item Name</label>
                    <Select
                      value={itemNameModal || undefined}
                      onChange={setItemNameModal}
                      showSearch
                      className="w-100"
                      placeholder="Select Name"
                      optionFilterProp="children"
                    >
                      {allItems.map((item) => (
                        <Option key={item.id} value={item.id}>
                          {item.dieName}
                        </Option>
                      ))}
                    </Select>
                  </div>

                  <div className="col-md-6 col-lg-4 py-1">
                    <label className="labels">Temper</label>
                    <Select
                      value={temperModal || undefined}
                      onChange={setTemperModal}
                      showSearch
                      className="w-100"
                      placeholder="Select Temper"
                      optionFilterProp="children"
                    >
                      {allTemper.map((temper) => (
                        <Option key={temper.id} value={temper.id}>
                          {temper.temperName}
                        </Option>
                      ))}
                    </Select>
                  </div>

                  <div className="col-md-6 col-lg-4 py-1">
                    <label className="labels">Psc</label>
                    <Input
                      value={pcsModal}
                      onChange={(e) => setPcsModal(e.target.value)}
                      placeholder="Enter Rate"
                      maxLength={250}
                    />
                  </div>

                  <div className="col-md-6 col-lg-4 py-1">
                    <label className="labels">Packing Rate</label>
                    <Input
                      value={packingDetailsRateModal}
                      onChange={(e) =>
                        setPackingDetailsRateModal(e.target.value)
                      }
                      placeholder="Enter Packing Rate"
                      maxLength={250}
                    />
                  </div>

                  <div className="col-md-6 col-lg-4 py-1">
                    <label className="labels">Unit</label>
                    <Select
                      value={unitModal || undefined}
                      onChange={setUnitModal}
                      showSearch
                      className="w-100"
                      placeholder="Select Unit"
                      optionFilterProp="children"
                    >
                      {goodTypesOptions.map((opt) => (
                        <Option key={opt.value} value={opt.value}>
                          {opt.label}
                        </Option>
                      ))}
                    </Select>
                  </div>

                  <div className="col-md-6 col-lg-4 py-1">
                    <label className="labels">Weight Range (12ft)</label>
                    <Input
                      type="number"
                      value={weightRangeModal}
                      onChange={(e) => setWeightRangeModal(e.target.value)}
                      placeholder="Enter Range"
                      maxLength={250}
                    />
                  </div>

                  <div className="col-md-6 col-lg-4 py-1">
                    <label className="labels">Qty (Kgs)</label>
                    <Input
                      value={qtyModal}
                      onChange={(e) => setQtyModal(e.target.value)}
                      placeholder="Enter Color"
                      maxLength={250}
                    />
                  </div>

                  <div className="col-md-6 col-lg-4 py-1">
                    <label className="labels">Premium</label>
                    <Input
                      type="number"
                      value={premiumDetailsModal}
                      onChange={(e) => setPremiumDetailsModal(e.target.value)}
                      placeholder="Enter Premium"
                      maxLength={250}
                    />
                  </div>

                  <div className="col-md-6 col-lg-4 py-1">
                    <label className="labels">Total</label>
                    <Input
                      readOnly
                      value={totalRateModal}
                      // onChange={(e) => setTotalRateModal(e.target.value)}
                      placeholder="Enter Rate"
                      maxLength={250}
                    />
                  </div>
                </div>

                <div className="row p-0 m-0">
                  <div className="col-12  text-center pt-3">
                    <Button
                      type="submit"
                      className="CancelBtn mx-1"
                      onClick={() => setIsModalVisible(false)}
                    >
                      Cancel
                    </Button>
                    <Button
                      type="submit"
                      className="SubmitBtn mx-1"
                      onClick={handleOrderDetailsUpdate}
                    >
                      Update Order Details
                    </Button>
                  </div>
                </div>
              </div>
            </Modal>
          </div>
        )}
      </div>
    </>
  )
}

export default OrderEntry
